import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import configs, { getParameterByName } from "../Constants";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Currencies from "./Currencies";
import { useIntl } from "react-intl";

function BillPrint(props) {
  console.log(props);
  const [loading, setLoading] = useState(true);
  const [print, setPrint] = useState(true);
  const [orderDetails, setOrderDetails] = useState(null);
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  let settings = sessionStorage.getItem('merchantData') ? JSON.parse(sessionStorage.getItem('merchantData')) : "";
  let cashier = userData ? userData.firstName : "";
  const orderId = props.orderDetails
    ? props.orderDetails.orderId
    : getParameterByName("orderId");
  const currency = props.orderDetails
    ? props.orderDetails.currency
    : getParameterByName("currency");
  const restaurant = props.orderDetails
    ? props.orderDetails.restaurant
    : getParameterByName("restaurant");
  let address = props.orderDetails
    ? props.orderDetails.address
    : getParameterByName("address");
  let locale = props.orderDetails
    ? props.orderDetails.locale
    : getParameterByName("locale");

  const cgst = getParameterByName("cgst");
  const nssi = getParameterByName("nssi");
  console.log("props details", props.orderDetails);
  const invoiceNo = props.orderDetails
    ? props.orderDetails.invoice_no
    : getParameterByName("invoice_no");
  const merchantCode = props.orderDetails
    ? props.orderDetails.merchantCode
    : getParameterByName("merchantCode");
  const baseURL = configs.baseURL;

  // let taxPerc = props.orderDetails.orderType.toLowerCase()=='eat in'? (taxPercent || dineinTax): (taxPercent || takeAwayTax);
  const { formatMessage: t } = useIntl();
  // const [canvasUrl, setCanvasUrl] = useState(null);
  const billRef = useRef(null);
  useEffect(() => {
    if (orderId) {
      const getBill = `${baseURL}/api/orders/${orderId}?merchantCode=${merchantCode}`;
      axios.get(getBill).then((response) => {
        setOrderDetails(response.data);
        setLoading(false);
      });
    }
  }, [orderId, merchantCode, baseURL]);
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: currency || 'USD'
  });
  let orderPrint = {}
  useEffect(() => {
    console.log(props.orderDetails);
    console.log(orderDetails);
    let isPrinted = localStorage.getItem("isPrintCall");
    if (props.orderDetails && isPrinted === "N" && !loading) {
      let printDetails = {};
      let kitchensUsed = [];
      printDetails.printType = props.orderDetails.printType ? props.orderDetails.printType : "receipt";

      printDetails.tokenNo = settings.bizVertical.toLowerCase() != 'retail' ? "Token #" + orderDetails.number : "";
      printDetails.merchant = restaurant;
      printDetails.invoiceNo = t({ id: "invoice" }) + "#:" + invoiceNo;
      printDetails.date = moment(orderDetails.createdAt).format(
        "DD-MMM-YYYY h:mm a"
      );
      printDetails.cashier = "Cashier: " + props.orderDetails.cashier || cashier;
      printDetails.header1 = t({ id: "items" });
      printDetails.header2 = t({ id: "quantity" });
      printDetails.header3 = t({ id: "amountlbl" });
      printDetails.orderItems = [];
      printDetails.receiptNote = props.orderDetails.receiptNote || "";
      printDetails.logoImg = props.orderDetails.logoImg || "";
      printDetails.cashOut = props.orderDetails.cashOut || orderDetails.cashOut || "";
      printDetails.kitchens = props.orderDetails.kitchens || [];
      printDetails.locale = props.orderDetails.locale || "";
      printDetails.discount = "Discount: " + formatter.format(orderDetails.discountAmount || 0).replace('JMD', 'J$').replace(/\s+/, "");
      printDetails.discountAmount = printDetails.discount;
      //printDetails.currencyIcon=<CurrencySymbol/>;
      printDetails.currency = currency;
      printDetails.address = address;
      printDetails.customer = props.orderDetails.customerName ? ("Name: " + props.orderDetails.customerName + " ,Ph.:" + props.orderDetails.customerPhone + ",Add.: " + props.orderDetails.customerAddress) : (props.orderDetails.customer ? ("Name: " + props.orderDetails.customer?.firstName + " ,Ph.:" + props.orderDetails.customer?.phone + ",Add.: " + props.orderDetails.customer?.address) : (props.orderDetails.customerInfo ? ("Name: " + props.orderDetails.customerInfo?.firstName + " ,Ph.:" + props.orderDetails.customerInfo?.phone + ",Add.: " + props.orderDetails.customerInfo?.address) : ""));
      printDetails.subTotal = formatter.format((orderDetails.totalPrice - orderDetails.taxPrice)).replace('JMD', 'J$').replace(/\s+/, "");
      if (orderDetails.taxPrice && orderDetails.taxPrice > 0) {
        printDetails.tax =
          "(" +
          props.orderDetails.taxPerc +
          "%) " + formatter.format(orderDetails.taxPrice).replace('JMD', 'J$').replace(/\s+/, "");
      }
      printDetails.isTaxShow = orderDetails.taxPrice > 0 ? true : false;
      if (props.orderDetails.serviceCharge) {
        printDetails.serviceCharge =
          t({ id: "serviceCharge" }) +
          " " + formatter.format(orderDetails.serviceCharge).replace('JMD', 'J$').replace(/\s+/, "");
      }
      printDetails.total =
        t({ id: "total" }) +
        ": " + formatter.format(orderDetails.totalPrice).replace('JMD', 'J$').replace(/\s+/, "");
      printDetails.payVia = orderDetails.payVia;
      printDetails.splitPayVia = orderDetails.splitPayVia;
      printDetails.splitAmount = orderDetails.splitAmount;

      let AddorderItems =
        orderDetails &&
        orderDetails.orderItems &&
        orderDetails.orderItems.map((item, index) => {
          const subPro = item.sub_pro ? JSON.parse(item.sub_pro) : {};
          const addonNames = subPro.addons
            ?.map((a) => a.name)
            .join(",");
          const varietyNames = subPro.variety
            ? Object.keys(subPro.variety).join(",")
            : "";
          const cookInst = subPro.cookInstructions.join(',');
          item.price = formatter.format(item.price).replace('JMD', 'J$').replace(/\s+/, "");
          item.quantity = item.select_type === "weight"
            ? `${(item.quantity / 1000).toFixed(2)}K/L `
            : item.quantity;
          item.addOnsStr = addonNames;
          item.varNames = varietyNames;
          item.notes = cookInst;
          item.appliedOfferDescription = item.appliedOfferDescription ? item.appliedOfferDescription : "";
          if (item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1) {
            kitchensUsed.push(item.kitchenId);
          }
          printDetails.orderItems.push(item);
        });

      localStorage.setItem("isPrintCall", "Y");
      let bill = document.getElementById("bill");
      orderPrint = printDetails;
      console.log('=============', orderPrint);
      if (bill) {
        //html2canvas(bill).then((canvas) => {
        //const canvasUrl = canvas.toDataURL("image/png");
        //const base64Image = canvasUrl.split(",")[1];
        console.log(printDetails);
        let isAndroid = false;
        if (window.PrintInterface) {
          isAndroid = true;
          window.PrintInterface.print(JSON.stringify(printDetails));

        }
        if (!isAndroid && window?.chrome?.webview?.postMessage) {
          window.chrome.webview.postMessage(printDetails);
        }
        localStorage.setItem("isPrintCall", "N");
        props.setBillPrint(false);
        localStorage.removeItem("ordId");
        localStorage.removeItem("newOrder");
        // }).catch(error => {
        //   console.error("Error capturing the bill:", error);
        // });
      }
    }
  }, [loading]);

  function handlePrint() {
    setPrint(false);

    const printButtonContainer = document.getElementById("print-container");
    if (printButtonContainer) {
      printButtonContainer.style.display = "none";
    }

    // if (window.PrintInterface && typeof window.PrintInterface.print === 'function') {
    if (window.PrintInterface) {
      window.PrintInterface.print();
      console.log("mobile");
    } else {
      console.log("print details", orderPrint);
      window.print();

    }
    localStorage.removeItem("ordId");
    localStorage.removeItem("newOrder");
  }

  function curSymbol() {
    let cur = Currencies.filter(
      (curen) => curen.abbreviation == currency.toUpperCase()
    );
    console.log(cur);
    return cur.length && cur[0].symbol;
  }

  const handleBack = () => {
    let isMerchant = sessionStorage.getItem("isMerchant");
    sessionStorage.setItem("billing", false);
    console.log(isMerchant);
    if (isMerchant) {
      window.location.href = `/epos?merchantCode=${merchantCode}`;
    } else {
      window.location.href = "/epos";
    }
  };

  const renderCurrencySymbol = () => {
    return <span dangerouslySetInnerHTML={{ __html: curSymbol() }} />;
  };
  //const [addressPart, gstPart, fssaiPart] = address
  const bodystyle = props.orderDetails
    ? { position: "absolute", zIndex: "-1" }
    : {};
  // console.log(orderDetails);
  return (
    <div style={bodystyle}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <ArrowBackIcon onClick={handleBack} style={{ marginLeft: "10px" }} />
        <div
          id="print-container"
          style={
            print
              ? {
                display: "block",
                textAlign: "left",
                marginLeft: "180px",
                marginTop: "10px",
              }
              : { display: "none" }
          }
        >
          <button id="print" onClick={handlePrint}>
            {t({ id: "print" })}
          </button>
        </div>
      </div>

      <div id="bill">
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <img
              id="load"
              style={{ width: "400px", height: "400px", marginLeft: "10px" }}
              src="/billsummary/loading-icon.gif"
            />
          </div>
        ) : (
          <div
            className="container"
            style={{
              textAlign: "left",
              justifyContent: "start",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div id="orderDetails" style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "inline",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                Token:
              </span>
              {settings.bizVertical.toLowerCase() !== 'retail' && <h5
                style={{ textAlign: "left", margin: "5px", display: "inline" }}
              >
                #{orderDetails.number}
              </h5>}
              <div
                style={{
                  display: "none",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span id="status_chip"> {t({ id: "preparing" })}</span>
              </div>
              <h6
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "bold",
                  margin: "10px",
                }}
              >
                {t({ id: "order_summary" })}
              </h6>
              <div>
                <b
                  style={{
                    display: "block",
                    height: "20px",
                    width: "100%",
                    textAlign: "center",
                    margin: "10px",
                    fontSize: "1.1em",
                  }}
                >
                  {restaurant}
                </b>
                <p>{address ? address.trim() : ""}</p>
              </div>

              <div
                style={{
                  textAlign: "left",
                  lineHeight: "8px",
                  width: "100%",
                  fontSize: "8px",
                }}
              >
                <p>
                  {t({ id: "invoice" })}#: {invoiceNo}
                </p>
                <p>
                  {moment(orderDetails.createdAt).format("DD-MM-YYYY h:mm a")}
                </p>
              </div>
              <div
                style={{
                  textAlign: "left",
                  lineHeight: "8px",
                  width: "100%",
                  fontSize: "8px",
                }}
              >
                <p>
                  {"Cashier: " + cashier}
                </p>

              </div>
              <hr style={{ border: "1px solid black", margin: "5px" }} />
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr style={{ borderBottom: "1px solid #000" }}>
                    <th
                      align="left"
                      style={{ padding: "4px", fontSize: "9px" }}
                    >
                      Items
                    </th>
                    <th
                      align="center"
                      style={{ padding: "1px", maxWidth: "20px", fontSize: "9px" }}
                    >
                      Qty/Wt
                    </th>
                    <th
                      align="center"
                      style={{ padding: "1px", fontSize: "9px" }}
                    >
                      Rate
                    </th>
                    <th
                      align="center"
                      style={{ padding: "1px", fontSize: "9px" }}
                    >
                      {t({ id: "ammount" })}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {orderDetails?.orderItems.map((item, index) => {
                    const subPro = item.sub_pro ? JSON.parse(item.sub_pro) : {};
                    const addonNames = subPro.addons
                      ?.map((a) => a.name)
                      .join(", ");
                    const varietyNames = subPro.variety
                      ? Object.keys(subPro.variety).join(", ")
                      : "";
                    const cookInst = subPro.cookInstructions.join(',');
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td
                            style={{
                              padding: "1px",
                              maxWidth: "200px",
                              textAlign: "left",
                              fontSize: "10px",
                              lineHeight: "1.4",
                            }}
                          >
                            <strong>{item.name}</strong>
                            {item.appliedOfferDescription ? <span style={{ marginLeft: "5px", color: "blue", border: "1px solid blue", padding: "1px 4px", fontSize: "10px", fontWeight: "bold" }}> {item.appliedOfferDescription.toUpperCase()}</span> : ""}
                            {(addonNames || varietyNames || cookInst) && (
                              <div
                                style={{
                                  fontSize: "8px",
                                  color: "#555",
                                  lineHeight: "1.2",
                                }}
                              >
                                {addonNames && (

                                  <span style={{ fontWeight: 500, fontSize: "10px" }}>
                                    {addonNames}
                                  </span>

                                )}
                                {varietyNames && (

                                  <span style={{ fontWeight: 500, fontSize: "10px", marginLeft: "10px" }}>
                                    {varietyNames}
                                  </span>

                                )}
                                {cookInst.length > 2 && (

                                  <span style={{ fontWeight: 500, fontSize: "10px", marginLeft: "10px" }}>
                                    {cookInst}
                                  </span>

                                )}
                              </div>
                            )}
                          </td>
                          <td style={{ fontSize: "12px", textAlign: "center" }}>
                            {item.select_type === "weight"
                              ? `${(item.quantity / 1000).toFixed(2)} kg/l`
                              : item.quantity}
                          </td>
                          <td style={{ fontSize: "12px", textAlign: "center" }}>
                            {renderCurrencySymbol()} {item.price}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                            }}
                          >
                            {renderCurrencySymbol()}{" "}
                            {item.select_type === "weight"
                              ? ((item.quantity * item.price) / 1000).toFixed(2)
                              : (item.quantity * item.price).toFixed(2)}
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}

                  {/* Divider */}
                  <tr>
                    <td colSpan="4">
                      <hr
                        style={{ border: "1px solid #000", margin: "8px 0" }}
                      />
                    </td>
                  </tr>

                  {/* Amount */}
                  <tr>
                    <td ></td>
                    <td
                      style={{
                        padding: "1px",
                        textAlign: "right",
                        fontSize: "12px",
                      }}
                    >
                      <b>Amount:</b>
                    </td>
                    <td
                      colSpan="2"
                      style={{ padding: "1px", textAlign: "right" }}
                    >
                      {renderCurrencySymbol()}{" "}
                      {orderDetails.orderItems
                        .reduce((sum, item) => {
                          // Check if the item is weight-based or quantity-based
                          if (item.select_type === "weight") {
                            return sum + (item.quantity * item.price) / 1000; // Convert weight to kg if in grams
                          } else {
                            return sum + item.price * (item.quantity || 1); // Regular quantity-based item
                          }
                        }, 0)
                        .toFixed(2)}
                    </td>
                  </tr>

                  {/* Tax (Same Line % and Amount) */}
                  {orderDetails?.taxPrice == 0 ? <tr>
                    <td ></td>
                    <td
                      style={{
                        padding: "1px",
                        textAlign: "right",
                        fontSize: "12px",
                      }}
                    >
                      {/* <b>Tax ({parseFloat(cgst || 0).toFixed(2)}%):</b> */}
                      <b>Tax:</b>
                    </td>
                    <td
                      colSpan="2"
                      style={{ padding: "1px", textAlign: "right" }}
                    >
                      {renderCurrencySymbol()}{" "}
                      {(orderDetails.taxPrice).toFixed(2)}
                    </td>
                  </tr> : ""}
                  {orderDetails?.serviceCharge ? <tr>
                    <td ></td>
                    <td
                      style={{
                        padding: "1px",
                        textAlign: "right",
                        fontSize: "12px",
                      }}
                    >
                      {/* <b>Tax ({parseFloat(cgst || 0).toFixed(2)}%):</b> */}
                      <b>Service Charge:</b>
                    </td>
                    <td
                      colSpan="2"
                      style={{ padding: "1px", textAlign: "right" }}
                    >
                      {formatter.format(orderDetails.serviceCharge).replace('JMD', 'J$').replace(/\s+/, "")}
                    </td>
                  </tr> : ""}
                  {false && <tr>
                    <td ></td>
                    <td
                      style={{
                        padding: "4px",
                        textAlign: "right",
                        fontSize: "12px",
                      }}
                    >
                      {/* <b>Tax ({parseFloat(cgst || 0).toFixed(2)}%):</b> */}
                      <b>SGST:</b>
                    </td>
                    <td
                      colSpan="2"
                      style={{ padding: "4px", textAlign: "right" }}
                    >
                      {renderCurrencySymbol()}{" "}
                      {(orderDetails.taxPrice / 2).toFixed(2)}
                    </td>
                  </tr>}

                  {/* Discount */}
                  <tr>
                    <td ></td>
                    <td
                      style={{
                        padding: "4px",
                        textAlign: "right",
                        fontSize: "12px",
                      }}
                    >
                      <b>Discount:</b>
                    </td>
                    <td
                      colSpan="2"
                      style={{ padding: "4px", textAlign: "right" }}
                    >
                      {orderDetails.discountAmount
                        ? `-${orderDetails.discountAmount}${orderDetails.discountType === "price" ? `${renderCurrencySymbol()}` : "%"
                        }`
                        : "-0%"}
                    </td>
                  </tr>
                  {orderDetails.orderType !== "Eat In" &&
                    orderDetails.orderType !== "Table Order" && (
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            margin: "4px",
                            textAlign: "center",
                            fontSize: "12px",
                          }}
                        >
                          <b>Container Price:</b>
                        </td>
                        <td
                          colSpan="2"
                          style={{ padding: "4px", textAlign: "right" }}
                        >
                          {renderCurrencySymbol()}{" "}
                          {orderDetails?.orderItems?.length > 0
                            ? orderDetails.orderItems
                              .reduce(
                                (sum, item) =>
                                  sum + (item.container_price || 0),
                                0
                              )
                              .toFixed(2)
                            : 0}
                        </td>
                      </tr>
                    )}
                  {orderDetails.cashOut && (
                    <tr>
                      <td
                        colSpan="2"
                        style={{
                          margin: "4px",
                          textAlign: "center",
                          fontSize: "12px",
                        }}
                      >
                        <b>Cash Out:</b>
                      </td>
                      <td
                        colSpan="2"
                        style={{ padding: "4px", textAlign: "right" }}
                      >
                        {renderCurrencySymbol()}{" "}
                        {orderDetails.cashOut}
                      </td>
                    </tr>
                  )}
                  {/* Final Total */}
                  {false && <tr
                    style={{
                      borderTop: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <td colSpan="2"></td>
                    <td
                      style={{
                        padding: "6px",
                        textAlign: "right",
                        fontSize: "13px",
                      }}
                    >
                      <b>Total:</b>
                    </td>
                    <td
                      style={{
                        padding: "1px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "13px",
                      }}
                    >
                      {formatter.format(orderDetails.totalPrice).replace('JMD', 'J$')}
                    </td>
                  </tr>}
                </tbody>
              </table>
              <h3
                align="left"
                style={{
                  margin: "5px",
                  fontSize: "20px",
                  fontWeight: "bold",
                  display: "table",
                  textAlign: "left",
                }}
                id="tot"
              >
                {t({ id: "total" })}:
                {orderDetails.orderSource.toUpperCase() === "EPOS" ? (
                  <>{formatter.format(orderDetails.totalPrice).replace('JMD', 'J$')}</>
                ) : (
                  <>
                    {renderCurrencySymbol()}{" "}
                    {orderDetails.discountType === "price" ||
                      orderDetails.discountType === "discount"
                      ? formatter.format((
                        orderDetails.totalPrice - orderDetails.discountAmount
                      )).replace('JMD', 'J$')
                      : orderDetails.discountType === "percentage"
                        ? formatter.format((
                          orderDetails.totalPrice -
                          (orderDetails.totalPrice *
                            orderDetails.discountAmount) /
                          100
                        )).replace('JMD', 'J$')
                        : formatter.format(orderDetails.totalPrice).replace('JMD', 'J$')}
                  </>
                )}
              </h3>
            </div>
            <p>------------Customer--------------</p>
            <p
              style={{ textAlign: "left", fontSize: "6px", maxWidth: "220px" }}
            >
              {"Name: " + orderDetails?.customerName + "  Ph.:" + orderDetails?.customerPhone}
            </p>
            <p>{"Address:" + orderDetails?.customerAddress}</p>
            <p>----------------------------------</p>
            <p
              style={{ textAlign: "left", fontSize: "6px", maxWidth: "220px" }}
            >
              {settings.receiptNotes}
            </p>
            <p
              style={{
                textAlign: "right",
                marginTop: "10px",
                float: "right",
                fontSize: "10px",
              }}
            >
              <i>Powered by</i> <b>{configs.productName}</b>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BillPrint;
